"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCss = void 0;
var emotion_1 = require("emotion");
var useTheme_1 = require("./useTheme");
exports.useCss = function () {
    var theme = useTheme_1.useTheme();
    return { theme: theme, css: emotion_1.css };
};
//# sourceMappingURL=useCss.js.map